/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CellStatusFromJSON, CellStatusToJSON } from './';
export function CellRepresentationFromJSON(json) {
    return CellRepresentationFromJSONTyped(json, false);
}
export function CellRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        value: json['value'],
        description: json['description'],
        jsonData: json['jsonData'],
        date: json['date'] === null ? null : new Date(json['date']),
        status: CellStatusFromJSON(json['status']),
        uniqueId: json['uniqueId'],
        importJobId: json['importJobId'],
        tagIds: json['tagIds'],
        accountTagId: json['accountTagId'],
        readonly: json['readonly'],
    };
}
export function CellRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        value: value.value,
        description: value.description,
        jsonData: value.jsonData,
        date: value.date === null ? null : value.date.toISOString().substr(0, 10),
        status: CellStatusToJSON(value.status),
        uniqueId: value.uniqueId,
        importJobId: value.importJobId,
        tagIds: value.tagIds,
        accountTagId: value.accountTagId,
        readonly: value.readonly,
    };
}
